<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="1200">
    <v-card v-if="row != null">
      <ODialogBar title="Rede Wifi" :subtitle="subtitle" @close="dismiss" />
      <v-card-text class="d-flex w-full h-600 pa-0">
        <div class="w-200 grow-0 shrink-0 sidebar-border sidebar-bg">
          <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
        </div>
        <div class="grow-1 w-0">
          <TabContainer
            @reload="reload"
            :tabItems="tabItems"
            :currentTab="currentTab"
            :value="row"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { WifiNetwork } from '../../../models/index.js'
import NetworkDetailsTab from './NetworkDetailsTab.vue'
import NetworkUsageTab from './NetworkUsageTab.vue'
import NetworkMapTab from './NetworkMapTab.vue'
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'

export default {
  components: { DesktopSideBar, TabContainer },
  data() {
    return {
      id: null,
      row: null,
      currentTab: 'overview',
      tabItems: [
        { value: 'overview', label: 'Geral', component: NetworkDetailsTab },
        { value: 'usage', label: 'Utilização', component: NetworkUsageTab },
        { value: 'map', label: 'Mapa', component: NetworkMapTab },
      ]
    }
  },
  computed: {
    subtitle() {
      if (this.row == null || this.row.id == null) return ''
      return '#' + this.row.id
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.reload()
      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    reload() {
      this.$refs.dialog.$loading(async () => {
        this.row = await this.fetchData()
      })
    },

    async fetchData() {
      return await WifiNetwork.findById(this.id)
    }
  }
}
</script>

<style lang="sass"></style>
